import _typeof from "@babel/runtime/helpers/esm/typeof";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _setPrototypeOf from "@babel/runtime/helpers/esm/setPrototypeOf";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
function _wrapRegExp() { _wrapRegExp = function _wrapRegExp(e, r) { return new BabelRegExp(e, void 0, r); }; var e = RegExp.prototype, r = new WeakMap(); function BabelRegExp(e, t, p) { var o = RegExp(e, t); return r.set(o, p || r.get(e)), _setPrototypeOf(o, BabelRegExp.prototype); } function buildGroups(e, t) { var p = r.get(t); return Object.keys(p).reduce(function (r, t) { var o = p[t]; if ("number" == typeof o) r[t] = e[o];else { for (var i = 0; void 0 === e[o[i]] && i + 1 < o.length;) i++; r[t] = e[o[i]]; } return r; }, Object.create(null)); } return _inherits(BabelRegExp, RegExp), BabelRegExp.prototype.exec = function (r) { var t = e.exec.call(this, r); if (t) { t.groups = buildGroups(t, this); var p = t.indices; p && (p.groups = buildGroups(p, this)); } return t; }, BabelRegExp.prototype[Symbol.replace] = function (t, p) { if ("string" == typeof p) { var o = r.get(this); return e[Symbol.replace].call(this, t, p.replace(/\$<([^>]+)>/g, function (e, r) { var t = o[r]; return "$" + (Array.isArray(t) ? t.join("$") : t); })); } if ("function" == typeof p) { var i = this; return e[Symbol.replace].call(this, t, function () { var e = arguments; return "object" != _typeof(e[e.length - 1]) && (e = [].slice.call(e)).push(buildGroups(e, i)), p.apply(this, e); }); } return e[Symbol.replace].call(this, t, p); }, _wrapRegExp.apply(this, arguments); }
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.replace.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.weak-map.js";
import "core-js/modules/esnext.map.delete-all.js";
import "core-js/modules/esnext.map.every.js";
import "core-js/modules/esnext.map.filter.js";
import "core-js/modules/esnext.map.find.js";
import "core-js/modules/esnext.map.find-key.js";
import "core-js/modules/esnext.map.includes.js";
import "core-js/modules/esnext.map.key-of.js";
import "core-js/modules/esnext.map.map-keys.js";
import "core-js/modules/esnext.map.map-values.js";
import "core-js/modules/esnext.map.merge.js";
import "core-js/modules/esnext.map.reduce.js";
import "core-js/modules/esnext.map.some.js";
import "core-js/modules/esnext.map.update.js";
import "core-js/modules/esnext.weak-map.delete-all.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import Card from '~/components/cards/Card.vue';
import Marco from '~/components/cards/Marco.vue';
import SideScroll from '~/components/SideScroll.vue';
import Case from '~/components/thumbnails/Case.vue';
import Collapse from '~/components/collapse/Collapse.vue';
import CollapseButton from '~/components/collapse/Button.vue';
import DdButton from '~/components/DdButton.vue';
import Services from '~/components/cases/Services.vue';
export default {
  name: 'ProfileAbout',
  scrollToTop: false,
  components: {
    Card: Card,
    Marco: Marco,
    SideScroll: SideScroll,
    Case: Case,
    Collapse: Collapse,
    CollapseButton: CollapseButton,
    Services: Services,
    DdButton: DdButton,
    Panel: function Panel() {
      return import('~/components/panels/CasesPanel.vue');
    },
    Showreel: function Showreel() {
      return import('~/components/profile/Showreel.vue');
    },
    CasesList: function CasesList() {
      return import('~/components/lists/CasesList.vue');
    },
    WebpPicture: function WebpPicture() {
      return import('~/components/WebpPicture.vue');
    }
  },
  props: ['profile', 'type', 'isModer', 'isEmpty'],
  data: function data() {
    return {
      cases: [],
      casesLength: 0,
      services: [],
      servicesLength: 0,
      awardItems: [],
      awardItemsLength: 0,
      activeItem: null
    };
  },
  asyncData: function asyncData(_ref) {
    return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var $axios, error, route, app, slug, postData, serviceData, awardData;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            $axios = _ref.$axios, error = _ref.error, route = _ref.route, app = _ref.app;
            slug = route.params.profile;
            _context.next = 4;
            return Promise.all([$axios.$get("/publication/find", {
              params: {
                type: 'case',
                profile: slug,
                limit: 4
              }
            }), $axios.$get("".concat($axios.defaults.baseURL, "/companyservice/find"), {
              progress: false,
              params: {
                company: slug,
                populatecategory: 1,
                range: {
                  priority: {
                    $lt: 50
                  }
                }
              }
            }), $axios.$get("".concat($axios.defaults.baseURL, "/awarditem/get"), {
              progress: false,
              params: {
                profile: slug
              }
            })]).then(function (result) {
              var _result = _slicedToArray(result, 3);
              postData = _result[0];
              serviceData = _result[1];
              awardData = _result[2];
            }).catch(function (e) {});
          case 4:
            if (postData) {
              _context.next = 6;
              break;
            }
            return _context.abrupt("return", error({
              statusCode: 404,
              message: 'Курс не знайдено'
            }));
          case 6:
            return _context.abrupt("return", {
              cases: postData.posts,
              casesLength: postData.length,
              services: serviceData.companyServices,
              servicesLength: serviceData.companyServicesLength,
              awardItems: awardData.awardItems,
              awardItemsLength: awardData.awardItemsLength
            });
          case 7:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  computed: {
    isPro: function isPro() {
      return true; //this.profile.plan && this.profile.plan !== 'basic';
    },
    empty: function empty() {
      return !(this.profile.about || this.profile.description || this.profile.aboutMe) && this.isEmpty && !this.awards.length && !this.profile.showreelLink;
    },
    showOnboarding: function showOnboarding() {
      return this.empty && this.isModer;
    },
    locale: function locale() {
      return this.$i18n.locale;
    },
    hasStatistic: function hasStatistic() {
      return this.casesLength || this.awardsLength || this.profile.founded || this.profile.team;
    },
    contacts: function contacts() {
      var _this = this;
      var contacts = [];
      if (this.profile.phones) {
        this.profile.phones.forEach(function (contact) {
          contact.type = 'tel';
          contacts.push(contact);
        });
      }
      if (this.profile.emails) {
        this.profile.emails.forEach(function (contact) {
          contact.type = 'mailto';
          contacts.push(contact);
        });
      }
      if (this.profile.locations) {
        this.profile.locations.forEach(function (contact) {
          contact.type = 'location';
          contact.label = '';
          contact.label = contact.country;
          if (contact.country && contact.city) contact.label = "".concat(contact.label, ", ");
          if (contact.city) contact.label = "".concat(contact.label).concat(contact.city);
          contact.value = contact.adress;
          if (contact.code) {
            contact.helper = "".concat(_this.$t('postalCode'), ": ").concat(contact.code);
          }
          contacts.push(contact);
        });
      }
      return contacts;
    },
    awards: function awards() {
      var _this2 = this;
      var awards = [];
      if (!this.awardItems || !this.awardItems.length) return [];
      this.awardItems.forEach(function (item) {
        if (!item.award) return;
        var awardIndex = awards.findIndex(function (o) {
          return o.id == item.award.id;
        });
        if (item.client || item.clientCompany) {
          if (item.clientCompany) item.client = item.clientCompany;
          item.isClient = item.client.id == _this2.profile.id;
        }
        if (awardIndex < 0) {
          var award = item.award;
          award.items = [item];
          awards.push(award);
        } else {
          // delete item.award;
          awards[awardIndex].items.push(item);
        }
      });

      // Sort awards based on `this.company.awardsOrder` if it exists
      if (this.profile.awardsOrder && Array.isArray(this.profile.awardsOrder)) {
        var awardsOrderMap = new Map(this.profile.awardsOrder.map(function (id, index) {
          return [id, index];
        }));
        awards.sort(function (a, b) {
          var _awardsOrderMap$get, _awardsOrderMap$get2;
          return ((_awardsOrderMap$get = awardsOrderMap.get(a.id)) !== null && _awardsOrderMap$get !== void 0 ? _awardsOrderMap$get : Infinity) - ((_awardsOrderMap$get2 = awardsOrderMap.get(b.id)) !== null && _awardsOrderMap$get2 !== void 0 ? _awardsOrderMap$get2 : Infinity);
        });
      }
      return awards;
    }
  },
  methods: {
    // @see: https://css-tricks.com/better-line-breaks-for-long-urls/
    formatUrl: function formatUrl(url) {
      // Split the URL into an array to distinguish double slashes from single slashes
      var doubleSlash = url.split('//');

      // Format the strings on either side of double slashes separately
      var formatted = doubleSlash.map(function (str) {
        return (
          // Insert a word break opportunity after a colon
          str.replace(/*#__PURE__*/_wrapRegExp(/(:)/gi, {
            after: 1
          }), '$1<wbr>')
          // Before a single slash, tilde, period, comma, hyphen, underline, question mark, number sign, or percent symbol
          .replace(/*#__PURE__*/_wrapRegExp(/([#%,-\/\?@_~])/gi, {
            before: 1
          }), '<wbr>$1')
          // Before and after an equals sign or ampersand
          .replace(/*#__PURE__*/_wrapRegExp(/([&=])/gi, {
            beforeAndAfter: 1
          }), '<wbr>$1<wbr>')
        );
      }
      // Reconnect the strings with word break opportunities after double slashes
      ).join('//<wbr>');
      return formatted;
    },
    openAwardDetails: function openAwardDetails(item) {
      this.activeItem = item;
      this.$modalityStore.openModal({
        type: 'drawer',
        name: 'award-details'
      });
    },
    pickLevelLocale: function pickLevelLocale(item) {
      return usePickAwardLevelLocale(item);
    }
  }
};